/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Lastused1Inputs */

const zh_usage_lastused1 = /** @type {(inputs: Usage_Lastused1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期`)
};

const en_usage_lastused1 = /** @type {(inputs: Usage_Lastused1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const es_usage_lastused1 = /** @type {(inputs: Usage_Lastused1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Usage_Lastused1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const usage_lastused1 = /** @type {((inputs?: Usage_Lastused1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Lastused1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usage_lastused1(inputs)
	if (locale === "en") return en_usage_lastused1(inputs)
	return es_usage_lastused1(inputs)
});
export { usage_lastused1 as "usage_lastUsed" }